import client from '../httpClient';

// 【webres010】未処理反響一覧取得（組織ID/社員所属指定）
const webResListByDivisionIdPostApi = (params, loadingId) => {
  return client.post('/responses/division', params, { loadingId });
};

export default webResListByDivisionIdPostApi;
